import TireMakes from "src/container/Administration/TireMakes";
import TireMeasures from "src/container/Administration/TireMeasures";
import TireModels from "src/container/Administration/TireModels";
import TirePresets from "src/container/Administration/TirePresets";

import SettingsLayout from "./SettingsLayout";
import { tireSettingsTabs } from "./settingsRoutes";

type TireSettingsTab = "brand" | "model" | "measure" | "preset";

interface TireSettingsPageProps {
  tab: TireSettingsTab;
}

const tireSettingsContent = {
  brand: <TireMakes />,
  model: <TireModels />,
  measure: <TireMeasures />,
  preset: <TirePresets />,
};

const TireSettingsPage = ({ tab }: TireSettingsPageProps) => (
  <SettingsLayout titleKey="tire_settings" activeKey={tab} tabs={tireSettingsTabs}>
    {tireSettingsContent[tab]}
  </SettingsLayout>
);

export default TireSettingsPage;
